import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";
import { useAcceptConnectionForUser } from "./useAcceptConnectionForUser";
import { useIgnoreConnectionForUser } from "./useIgnoreConnectionForUser";

interface RespondButtonsProps {
  connectionId?: string;
  memberName?: string;
  memberPublicUid?: string;
  shouldShowOnlyIcon?: boolean;
}

export const RespondButtons = ({
  memberPublicUid,
  memberName,
  connectionId,
  shouldShowOnlyIcon = false,
}: RespondButtonsProps) => {
  const { acceptConnectionForUser, isAccepting } = useAcceptConnectionForUser({
    memberPublicUid,
    memberName,
  });

  const { ignoreConnectionForUser, isIgnoring } = useIgnoreConnectionForUser({
    memberPublicUid,
  });

  const handleAcceptConnection = () => {
    if (!connectionId) {
      return;
    }

    acceptConnectionForUser(connectionId);
  };

  const handleIgnoreConnection = () => {
    if (!connectionId) {
      return;
    }

    ignoreConnectionForUser(connectionId);
  };

  return (
    <div className="flex gap-x-2">
      <Button
        variant="secondary"
        onClick={handleIgnoreConnection}
        disabled={isIgnoring || isAccepting}
        aria-label={t("profile_drawer.connect_banner.states.ignore")}
        className={classNames(shouldShowOnlyIcon && "!h-8 !w-8 !p-0")}
      >
        {isIgnoring ? (
          <Icon type="loader" viewBox="0 0 16 16" />
        ) : shouldShowOnlyIcon ? (
          <Icon type="20-close" size={20} />
        ) : (
          t("profile_drawer.connect_banner.states.ignore")
        )}
      </Button>
      <Button
        variant="primary"
        onClick={handleAcceptConnection}
        disabled={isAccepting || isIgnoring}
        aria-label={t("profile_drawer.connect_banner.states.accept")}
        className={classNames(
          shouldShowOnlyIcon && "!h-8 !w-8 !p-0 text-white dark:text-black",
        )}
      >
        {isAccepting ? (
          <Icon type="loader" viewBox="0 0 16 16" />
        ) : shouldShowOnlyIcon ? (
          <Icon type="20-checkmark" size={20} useWithFillCurrentColor />
        ) : (
          t("profile_drawer.connect_banner.states.accept")
        )}
      </Button>
    </div>
  );
};
